import { render } from "./AccountContactsContainer.vue?vue&type=template&id=2d2e0754"
import script from "./AccountContactsContainer.vue?vue&type=script&lang=js"
export * from "./AccountContactsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__